class ShipmentDateSelectController {
  constructor(selectedDate) {
    this.selectedDate = selectedDate;

    const minDate = new Date();
    minDate.setDate(minDate.getDate() + 1);

    this.datePickerOptions = {
      minDate: minDate,
      showWeeks: false,
      formatDay: 'd',
      currentMonth: minDate.getMonth(),
      currentYear: minDate.getFullYear()
    };
  }
}

ShipmentDateSelectController.$inject = ['selectedDate'];

module.exports = ShipmentDateSelectController;
